import { FileText } from 'lucide-react';
import AccountStatement from './components/AccountStatement';

export default function AccountStatementPage() {

  return (
    <div className="container mx-auto py-6 max-w-7xl">
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <FileText className="h-6 w-6" />
          <h1 className="text-xl font-semibold tracking-tight">Account Statement</h1>
        </div>
        <p className="text-muted-foreground">
          View detailed transaction history and balance information for any account in your chart of accounts.
        </p>
      </div>

      <AccountStatement />
    </div>
  );
}